import { takeLatest, takeEvery, put, call, race, take } from "redux-saga/effects";

import { filterActions } from "actions/filterActions.js";

import { GET_DATA } from "actions/apiOperations.js";

import { getData } from "sagas/getDataSaga.js";

export const requestFilters = function*(action) {
  const { releaseId, ...params } = action.payload;

  // Called rather than put as GET_DATA so the request can be cancelled - see
  // requestFiltersForActiveTab.
  yield call(getData, {
    path: `/api/releases/${releaseId}/filters.json`,
    actions: filterActions,
    params
  });
};

export const requestQuickFillFilters = function*(action) {
  const { brandId, ...params } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/brands/${brandId}/filters.json`,
    actions: filterActions,
    params: {
      ...params,
      metadata: {
        rangeType: "quickFill"
      }
    }
  });
};

export const requestStockModalFilters = function*(action) {
  const { releaseId, stockModalId, ...params } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/releases/${releaseId}/stock_models/${stockModalId}/filters.json`,
    actions: filterActions,
    params
  });
};

// Each tab fetches its own filters (RANGE, BUYPLAN, SUMMARY) into the same
// store. A request still in flight when the viewer switches tab is aborted: a
// slow Buy Plan tab response landing on the catalog would replace its filters
// with ones scoped to the buyplan's items and hide every other section.
// Requests are otherwise independent - the Whiteboard fetches RANGE and BUYPLAN
// filters together and needs both to complete.
export const requestFiltersForActiveTab = function*(action) {
  yield race({
    response: call(requestFilters, action),
    tabChanged: take(filterActions.setActiveTab)
  });
};

export const watchRequestFilters = function*() {
  yield takeEvery(filterActions.init, requestFiltersForActiveTab);
};

export const watchQuickFillRequestFilters = function*() {
  yield takeLatest(
    filterActions.requestQuickFillFilters,
    requestQuickFillFilters
  );
};

export const watchStockModalRequestFilters = function*() {
  yield takeLatest(
    filterActions.requestStockModalFilters,
    requestStockModalFilters
  );
};
